import { FullTextSearch, type TranslatedValue } from "@swo/storefront";
import { nonEmptyArray, option } from "fp-ts";
import { pipe } from "fp-ts/lib/function";
import React from "react";
import { PDPDownloadElements } from "../../../components/DownloadsCarouselComponent/PDPDownloadElements";
import { ReactTFC } from "../../../utils/fp/missing-ts-parts";
import { useSlice } from "../use-slice";
import { SearchT } from "./search-component";
import { SearchResultsViewSectionWithHeadline } from "./search-results-view-section-headline-with-children";
import { SeeMoreLabel } from "./see-more-label";
import { mapTranslatedValue } from "../../../components/T";

export const SearchResultsDownloadsViewSection: ReactTFC<{
  headline: TranslatedValue;
  downloads: FullTextSearch["downloads"];
  id: string;
  NoSearchResultsFound: React.JSX.Element;
  t: SearchT;
}> = ({ t, ...props }) => {
  const slice = useSlice(props.downloads, 4);

  return (
    <SearchResultsViewSectionWithHeadline id={props.id} headline={props.headline}>
      {pipe(
        nonEmptyArray.fromArray(slice.slice),
        option.fold(
          () => props.NoSearchResultsFound,
          nea => (
            <React.Fragment>
              <PDPDownloadElements elements={nea} />

              {slice.shouldHaveLoadMoreButton && (
                <SeeMoreLabel
                  label={mapTranslatedValue(t("section.downloads.seeAll"), _ => `${_} (${props.downloads.length})`)}
                  onClick={slice.unslice}
                />
              )}
            </React.Fragment>
          ),
        ),
      )}
    </SearchResultsViewSectionWithHeadline>
  );
};
